// extracted by mini-css-extract-plugin
export default {"fullWidth":"Br-z","image":"Cr-z","lazyLoadPicture":"Dr-z","lazyLoadSpinner":"Er-z","lazyLoadSpin":"Fr-z","lazyLoadImage":"Gr-z","hasStyledAspectRatio":"Hr-z"};